import {
  useState,
  useMemo,
  createContext,
  ReactNode,
  useContext,
  Dispatch,
  SetStateAction,
} from "react";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";

interface ItotalChatsGraphData {
  count: number;
  date: string;
  pageId: string;
  pageName: string;
  source: "facebook" | "whatsapp" | "instagram";
}

interface ICreateContext {
  totalChatsGraphData: ItotalChatsGraphData[];
  setTotalChatsGraphData: Dispatch<SetStateAction<ItotalChatsGraphData[]>>;
  totalChatsGraphDataLoading: boolean;
  setTotalChatsGraphDataLoading: Dispatch<SetStateAction<boolean>>;
  activeChats: any;
  setActiveChats: (a: any) => void;
  totalChats: any;
  setTotalChats: (a: any) => void;
  storedAgentId: number;
  setStoredAgentId: Dispatch<SetStateAction<number>>;
  //
  timePeriod: string;
  setTimePeriod: Dispatch<SetStateAction<string>>;
  //
  globalTimeFrame: string;
  setGlobalTimeFrame: Dispatch<SetStateAction<string>>;
}

const context = createContext<ICreateContext | null>(null);

// contextProvider
interface IProvider {
  children: ReactNode;
}

const DashboardProvider = ({ children }: IProvider) => {
  const [totalChatsGraphDataLoading, setTotalChatsGraphDataLoading] =
    useState<boolean>(false);

  const [totalChatsGraphData, setTotalChatsGraphData] = useState<
    ItotalChatsGraphData[]
  >([]);
  const [activeChats, setActiveChats] = useState<number>(0);
  const [totalChats, setTotalChats] = useState<number>(0);

  const { agentId: loggedInUserId } = useActiveUserDetail();
  const [storedAgentId, setStoredAgentId] = useState<number>(
    Number(loggedInUserId),
  );

  const [timePeriod, setTimePeriod] = useState<string>("week");
  const [globalTimeFrame, setGlobalTimeFrame] = useState<string>("today");

  const providerValue = useMemo(
    () => ({
      totalChatsGraphData,
      setTotalChatsGraphData,
      totalChatsGraphDataLoading,
      setTotalChatsGraphDataLoading,
      activeChats,
      setActiveChats,
      totalChats,
      setTotalChats,
      //
      storedAgentId,
      setStoredAgentId,
      //
      timePeriod,
      setTimePeriod,
      //
      globalTimeFrame,
      setGlobalTimeFrame,
    }),
    [
      totalChatsGraphDataLoading,
      totalChatsGraphData,
      activeChats,
      totalChats,
      storedAgentId,
      timePeriod,
      globalTimeFrame,
    ],
  );
  return <context.Provider value={providerValue}>{children}</context.Provider>;
};

// useContext
const UseDashboardContext = () => {
  return useContext(context);
};

export { DashboardProvider, UseDashboardContext };
